
import Vue from 'vue';
import { AutoTagRule, ExpressionMatcher } from '@/services/api';
import { formatAutoTagRule, parseAutoTagRule } from '@/services/autoTagRuleText';

type EditorMode = "visual" | "text";

export default Vue.extend({
    props: {
        rule: {
            required: true,
            type: Object as () => AutoTagRule
        }
    },
    data() {
        return {
            mode: "visual" as EditorMode,
            ruleText: "",
            textError: ""
        }
    },
    mounted() {
        this.ruleText = formatAutoTagRule(this.rule);
    },
    methods: {
        setMode(mode: EditorMode) {
            if (mode === "text") {
                this.ruleText = formatAutoTagRule(this.rule);
                this.textError = "";
            }
            this.mode = mode;
        },
        applyText() {
            try {
                const parsed = parseAutoTagRule(this.ruleText);
                this.rule.tag = parsed.tag;
                this.rule.description = parsed.description;
                this.rule.matchers.splice(0, this.rule.matchers.length, ...parsed.matchers);
                this.textError = "";
                this.mode = "visual";
            } catch (e) {
                this.textError = e instanceof Error ? e.message : "Invalid rule text";
            }
        },
        addMatcher() {
            const matcher: ExpressionMatcher[] = [];
            this.addLine(matcher);
            this.rule.matchers.push(matcher);
        },
        deleteMatcher(matcher: ExpressionMatcher[]) {
            const index = this.rule.matchers.indexOf(matcher);
            if (index >= 0) {
                this.rule.matchers.splice(index, 1);
            }
        },
        addLine(matcher: ExpressionMatcher[]) {
            matcher.push({
                type: "Description",
                expression: ""
            });
        },
        removeLine(matcher: ExpressionMatcher[], line: ExpressionMatcher) {
            const index = matcher.indexOf(line);
            if (index >= 0) {
                matcher.splice(index, 1);
            }
            if (matcher.length === 0) {
                this.deleteMatcher(matcher);
            }
        }
    }
})
